import Nav from '../components/Nav';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Hero from '../components/sections/Hero';
import Principles from '../components/sections/Principles';
import Listings from '../components/sections/Listings';
import WhoWeServe from '../components/sections/WhoWeServe';
import OurDifference from '../components/sections/OurDifference';

export default function Home() {
  return (
    <>
      <SEO />
      <div className="min-h-screen bg-bg text-ink">
        <Nav />
        <main id="main">
          <Hero />
          <Principles />
          <Listings />
          <WhoWeServe />
          <OurDifference />
        </main>
        <Footer />
      </div>
    </>
  );
}
